import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface Device {
  id: string;
  rustdesk_id: string;
  hostname: string;
  company: string;
  company_name: string;
  os_type: string;
  os_version: string;
  ip_address: string | null;
  mac_address: string;
  status: string;
  last_seen: string | null;
  tags: string[];
  notes: string;
  registered_at: string;
}

export interface DeviceFormData {
  rustdesk_id: string;
  hostname: string;
  company: string;
  os_type: string;
  os_version: string;
  ip_address?: string;
  mac_address?: string;
  tags?: string[];
  notes?: string;
}

export interface DeviceRegisterData {
  rustdesk_id: string;
  hostname: string;
  os_type?: string;
  os_version?: string;
  ip_address?: string;
  mac_address?: string;
}

export const devicesApi = {
  list: async (params?: Record<string, any>): Promise<{ results: Device[]; count: number }> => {
    const response = await apiClient.get(API_ENDPOINTS.DEVICES.LIST, { params });
    return response.data;
  },

  get: async (id: string): Promise<Device> => {
    const response = await apiClient.get(API_ENDPOINTS.DEVICES.DETAIL(id));
    return response.data;
  },

  create: async (data: DeviceFormData): Promise<Device> => {
    const response = await apiClient.post(API_ENDPOINTS.DEVICES.CREATE, data);
    return response.data;
  },

  update: async (id: string, data: Partial<DeviceFormData>): Promise<Device> => {
    const response = await apiClient.patch(API_ENDPOINTS.DEVICES.UPDATE(id), data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.DEVICES.DELETE(id));
  },

  // Auto-registro (não requer autenticação)
  register: async (data: DeviceRegisterData): Promise<{ id: string; created: boolean; message: string }> => {
    const response = await apiClient.post(API_ENDPOINTS.DEVICES.REGISTER, data);
    return response.data;
  },

  // Heartbeat (não requer autenticação)
  heartbeat: async (rustdesk_id: string): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.DEVICES.HEARTBEAT, { rustdesk_id });
  },

  // Marcar como offline
  markOffline: async (rustdesk_id: string): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.DEVICES.OFFLINE, { rustdesk_id });
  },
};
